<div class="dp-page-num">
    <span class="num">{{current}}/{{total}}</span>
</div>